import { useEffect } from 'react';
import { getPaymentSession, SUBSCRIPTION_PLANS } from 'helpers/trustpayService';
import { requestStates, useRequestState } from 'hooks/useRequestState';
import styled from 'styled-components';

interface IPaymentActionsSectionProps {
  isExpiredSub: boolean;
}

const PaymentActionsSection: React.FC<IPaymentActionsSectionProps> = ({ isExpiredSub }) => {
  const { requestState, setLoading, setInitial, setFailed } = useRequestState(requestStates.initial);

  const handleGetPaymentSession = async (offerType: keyof typeof SUBSCRIPTION_PLANS) => {
    if (requestState.isLoading) return;
    try {
      setLoading();
      await getPaymentSession(offerType);
    } catch (error) {
      setFailed();
      throw error;
    }
  };


  useEffect(() => { setInitial(); }, []);

  return (
    <Root>
      <PremiumButton onClick={() => handleGetPaymentSession('yearDiscountOffer')} isLoading={requestState.isLoading} disabled={requestState.isLoading}>
        {requestState.isLoading ? <Skeleton /> : (
          <>
            <LeftPremiumButtonSection>
              Update to Yearly Plan
              <div><CrossedOutOfferText>89.99 USD</CrossedOutOfferText> <OfferText>44.99 USD</OfferText></div>
            </LeftPremiumButtonSection>
            <RightPremiumButtonSection>
              <HalfPercentOffTextWrapper>
                <HalfPercentOffText>Save 50%</HalfPercentOffText>
              </HalfPercentOffTextWrapper>
            </RightPremiumButtonSection>
          </>
        )}
      </PremiumButton>
      <DefaultButton onClick={() => handleGetPaymentSession('monthDiscountOffer')} isLoading={requestState.isLoading} disabled={requestState.isLoading}>
        {requestState.isLoading ? <Skeleton /> : (
          <LeftPremiumButtonSection>
            Update to Monthly Plan
            <div><CrossedOutOfferText>12.99 USD</CrossedOutOfferText> <OfferText>2.99 USD</OfferText></div>
          </LeftPremiumButtonSection>
        )}
      </DefaultButton>
      {isExpiredSub && (
        <DefaultButton onClick={() => handleGetPaymentSession('month14daysTrialOffer')} isLoading={requestState.isLoading} disabled={requestState.isLoading}>
          {requestState.isLoading ? <Skeleton /> : (
            <LeftPremiumButtonSection>
              14 Days - Free
              <div><OfferText>0.01 USD</OfferText></div>
            </LeftPremiumButtonSection>
          )}
        </DefaultButton>
      )}
    </Root>
  );
};

export default PaymentActionsSection;

const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const DefaultButton = styled.button<{ isLoading: boolean }>`
  padding: 6px 24px;
  height: 56px;
  width: 100%;
  font-size: 16px;
  font-weight: 700;
  border-radius: 50px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #282828;
  color: white;
  position: relative;
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const PremiumButton = styled(DefaultButton)`
  background: linear-gradient(90deg, #9e5eee 0%, #b759ea 32%, #c65de9 66%, #b885f4 100%);
`;

const LeftPremiumButtonSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const RightPremiumButtonSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const HalfPercentOffTextWrapper = styled.div`
  width: 68px;
  line-height: 12px;
  background: white;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
`;

const HalfPercentOffText = styled.span`
  font-size: 12px;
  font-weight: 700;
  background: linear-gradient(90deg, #9E5EEE 0%, #B759EA 32%, #C65DE9 66%, #B885F4 100%);
  background-clip: text;
  color: transparent;
`;

const OfferText = styled.span`
  font-size: 12px;
  font-weight: 700;
`;

const CrossedOutOfferText = styled(OfferText)`
  text-decoration: line-through;
  opacity: 0.6;
`;

const Skeleton = styled.div`
  height: 20px;
  width: 100%;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.2) 25%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.2) 75%);
  background-size: 200% 100%;
  border-radius: 4px;
  animation: shimmer 1.5s infinite linear;

  @keyframes shimmer {
    from {
      background-position: 200% 0;
    }
    to {
      background-position: -200% 0;
    }
  }
`;
